import { toHTML } from '@portabletext/to-html'
import { PortableTextBlock } from '@portabletext/types'
import blockTools from '@sanity/block-tools'
import Schema from '@sanity/schema'

const defaultSchema = Schema.compile({
  name: 'default',
  types: [
    {
      title: 'Bio',
      name: 'bio',
      type: 'object',
      fields: [
        {
          title: 'Content',
          name: 'content',
          type: 'array',
          of: [{ type: 'block' }],
        },
      ],
    },
  ],
})

const blockContentType = defaultSchema
  .get('bio')
  .fields.find((field: { name: string }) => field.name === 'content').type

export const htmlToBlocks = (html: string): PortableTextBlock[] =>
  blockTools.htmlToBlocks(html, blockContentType)

export const blocksToHtml = (blocks: PortableTextBlock[]): string =>
  toHTML(blocks, {
    // customize to produce html ReactQuill will render correctly
    components: {
      marks: {
        underline: ({ children }) => {
          return `<u>${children}</u>` // would otherwise be <span style="text-decoration:underline">
        },
        'strike-through': ({ children }) => {
          return `<s>${children}</s>` // would otherwise be <del>
        },
      },
    },
  })
